import { render, staticRenderFns } from "./UpdateModule.html?vue&type=template&id=59d66226&scoped=true&"
import script from "./UpdateModule.vue?vue&type=script&lang=js&"
export * from "./UpdateModule.vue?vue&type=script&lang=js&"
import style0 from "./UpdateModule.vue?vue&type=style&index=0&id=59d66226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d66226",
  null
  
)

export default component.exports